<template>
    <div>
        <div class="bg-grey vh-100" id="list_pembayaran">
            <!-- HEADER -->
            <div class="header-top bg-white">
                <div class="header-top--inner w-limit d-flex justify-content-between align-items-center">
                    <div class="header-top--left" @click="backtopenggajian">
                        <div class="header-item">
                            <img src="../../../assets/icons/back-blue.svg" alt="a">
                        </div>
                    </div>
                    <div class="header-top--middle f-cont f-16 f-bold">List Riwayat Pembayaran Gaji</div>
                    <div class="header-top--right" v-on:click="searchPembayaran">
                        <div class="header-item">
                            <img src="../../../assets/icons/search.svg" alt="">
                        </div>
                    </div>
                </div>
            </div>

            <div class="header-top bg-white showPageSearch">
                <div class="header-top--inner w-limit d-flex justify-content-between align-items-center">
                    <div class="header-top--left add-padding-default">
                        <input class="inputSearch" id="input_searchPembayaran" type="text" v-on:keyup="searchPembayaran" v-model="searchKeyPembayaran"
                               placeholder="Cari..">
                    </div>
                    <div class="header-top--right" v-on:click="closeSearchPembayaran">
                        <div class="header-item">
                            <img src="../../../assets/img/x2.svg" alt="">
                        </div>
                    </div>
                </div>
            </div>

	        <div class="showPageSearch pad-top-66">
		        <div class="content-wrapper bg-gray">

			        <div class="p-x-20 p-y-16 w-limit" v-if="listpembayaran.length===0 && searchKeyPembayaran.length > 2">
				        <!-- IF EMPTY -->
				        <h6 id="textSearch" class="font-14 remove-margin textTotalSearch">Tidak menemukan '{{ searchKeyPembayaran }}'</h6>
			        </div>
			        <!-- ITEMS -->
			        <div class="p-x-20 p-y-16 w-limit" v-else>
				        <!-- LIST ITEMS -->
				        <div class="card-item-wrapper mar-bot-12" v-for="pembayaran in listpembayaran" :key="pembayaran.id" @click="validateAccess('payrollHistory.read') && godetailpembayaran(pembayaran.idpembayarangaji)">

					        <div class="card-item">
						        <div class="top-card m-d-4">
							        <div class="f-14 f-c-black font-weight-bold" v-html="'ID: ' + searchHighlight(pembayaran.idpembayarangaji, searchKeyPembayaran)"></div>
							        <div class="card-chevron"></div>
						        </div>
						        <div class="f-14 f-c-black">
							        <img src="../../../assets/icons/user.svg" height="14px" alt="">
							        <span class="m-l-4" v-html="searchHighlight(pembayaran.karyawan_name, searchKeyPembayaran)"></span>
						        </div>
						        <div class="f-14 f-c-midgrey">
							        <img src="../../../assets/icons/file-text-grey.svg" height="14px" alt="">
							        <span class="m-l-4">{{pembayaran.judul_gaji}}</span>
						        </div>
						        <div class="f-14 f-c-midgrey">
							        <img src="../../../assets/icons/circle-info.svg" height="14px" alt="">
							        <span class="m-l-4">Tanggungan {{ pembayaran.nominal_tanggungan | currency }}</span>
						        </div>

						        <!--                                <div class="f-16 f-semi m-t-8">{{pembayaran.karyawan_name}}</div>-->
						        <!--                                <div class="f-14 f-semi m-t-8">{{pembayaran.judul_gaji}}</div>-->
						        <!--                                <div class="f-13 f-c-midgrey m-t-4">{{pembayaran.count_item_gaji}} Item Gaji • {{pembayaran.count_komisi}} Komisi • {{pembayaran.count_tanggungan}} Tanggungan</div>-->
						        <!--                                <div class="f-13 f-c-midgrey m-t-4">Periode : {{pembayaran.periode_gaji}} </div>-->
						        <!--                                <div class="f-13 f-c-midgrey m-t-4">ID : {{pembayaran.idpembayarangaji}} </div>-->

						        <div class="separator-line m-x-min m-t-10"></div>
						        <div class="bottom-card m-t-10">
							        <div class="f-14 f-semi" v-if="pembayaran.nominal_tanggungan > 0">
								        {{pembayaran.grand_total_gaji | currency}}
								        <br>
								        <span class="gaji-bersih">{{pembayaran.grand_total_gaji_bersih | currency}} setelah dikurangi tanggungan</span>
							        </div>
							        <div class="f-12 f-c-muted">{{pembayaran.payment_date}}</div>
						        </div>
					        </div>

				        </div>
				        <div class="loadmoreSpinner" id="loadingSpinnerListPembayaranSearch" style="display: none">
					        <center>
						        <div class="sp sp-circle"></div>
					        </center>
				        </div>
			        </div>

		        </div>
	        </div>


            <div class="showPageDefault">
                <!-- CONTENT -->
                <div class="content-wrapper main-page">

                    <div class="p-x-20 p-y-16 w-limit" v-if="leght_data_pembayaranx===0">
                        <!-- IF EMPTY -->
                        <div class="empty-state">
                            <div class="empty-state--icon"></div>
                            <div class="f-16 f-bold">Belum ada riwayat pembayaran gaji</div>
                            <div class="f-14 f-c-midgrey">Riwayat pembayaran akan tampil disini</div>
                        </div>
                    </div>
                    <!-- ITEMS -->
                    <div class="p-x-20 p-y-16 w-limit" v-else>

                        <div class="d-flex justify-content-between m-d-16">
                            <div class="f-16 f-c-midgrey">{{leght_data_pembayaranx}} Pembayaran</div>

                            <FilterSorting @filter="filter" :jenisFilter="'listPembayaran'" style="margin-top: -6px"/>
                        </div>
                        <!-- LIST ITEMS -->
                        <div class="card-item-wrapper mar-bot-12" v-for="pembayaran in listpembayaran" :key="pembayaran.id" @click="validateAccess('payrollHistory.read') && godetailpembayaran(pembayaran.idpembayarangaji)">

                            <div class="card-item">
                                <div class="top-card m-d-4">
                                  <div class="f-14 f-c-black font-weight-bold">ID : {{pembayaran.idpembayarangaji}}</div>
                                  <div class="card-chevron"></div>
                                </div>
                                <div class="f-14 f-c-midgrey">
                                  <img src="../../../assets/icons/user.svg" height="14px" alt="">
                                  <span class="m-l-4">{{pembayaran.karyawan_name}}</span>
                                </div>
                                <div class="f-14 f-c-midgrey">
                                  <img src="../../../assets/icons/file-text-grey.svg" height="14px" alt="">
                                  <span class="m-l-4">{{pembayaran.judul_gaji}}</span>
                                </div>
	                            <div class="f-14 f-c-midgrey" v-if="pembayaran.nominal_tanggungan > 0">
		                            <img src="../../../assets/icons/circle-info.svg" height="14px" alt="">
		                            <span class="m-l-4">Tanggungan {{ pembayaran.nominal_tanggungan | currency }}</span>
	                            </div>

<!--                                <div class="f-16 f-semi m-t-8">{{pembayaran.karyawan_name}}</div>-->
<!--                                <div class="f-14 f-semi m-t-8">{{pembayaran.judul_gaji}}</div>-->
<!--                                <div class="f-13 f-c-midgrey m-t-4">{{pembayaran.count_item_gaji}} Item Gaji • {{pembayaran.count_komisi}} Komisi • {{pembayaran.count_tanggungan}} Tanggungan</div>-->
<!--                                <div class="f-13 f-c-midgrey m-t-4">Periode : {{pembayaran.periode_gaji}} </div>-->
<!--                                <div class="f-13 f-c-midgrey m-t-4">ID : {{pembayaran.idpembayarangaji}} </div>-->

                                <div class="separator-line m-x-min m-t-10"></div>
                                <div class="bottom-card m-t-10">
                                    <div class="f-14 f-semi"  v-if="pembayaran.nominal_tanggungan > 0">
	                                    {{pembayaran.grand_total_gaji | currency}}
	                                    <br>
	                                    <span class="gaji-bersih f-c-midgrey">{{pembayaran.grand_total_gaji_bersih | currency}} setelah dikurangi tanggungan</span>
                                    </div>
                                    <div class="f-12 f-c-muted">{{pembayaran.payment_date}}</div>
                                </div>
                            </div>

                        </div>
                        <div class="loadmoreSpinner" id="loadingSpinnerListPembayaran" style="display: none">
                            <center>
                                <div class="sp sp-circle"></div>
                            </center>
                        </div>
                    </div>

                </div>
            </div>
            <div class="flying-button-wrapper" v-if="validateAccess('cashReceipt.create')">
                <div class="flying-inside">
                    <div class="flying-button btn-add-outlet" @click="add"></div>
                </div>
            </div>


        </div>
        <DetailRiwayatGaji v-bind:class="{hidesection: !isSetDetailPembayaran}" ref="setdetailpembayaran"
              v-on:back="isdetailpembayaran"  :idpembayarangaji="idpembayarangaji" />
    </div>


</template>

<script>
    import FilterSorting from "@/component-items/FilterSorting";
    import DetailRiwayatGaji from "./DetailRiwayatGaji";

    export default {
        name: "RiwayatPembayaran",
        components: {DetailRiwayatGaji, FilterSorting },
        data(){
            return{
                idpembayarangaji:"",
                isSetDetailPembayaran: false,
                listpembayaran:[],
                leght_data_pembayaranx:'',
                searchKeyPembayaran:'',
                leght_data_Pembayaran:'',
                requestHeaders: {
                    headers: {
                        'Authorization': 'Bearer ' + localStorage.getItem('token'),
                    }
                },

                listPembayaranPagination: {
                    limit: 20,
                    offset:0,
                    length: 0,
                    pageNumber: 0,
                    sortBy: "created_at",
                    orderBy: "DESC",
                },
                listPembayaranSearchPagination: {
                    limit: 20,
                    offset:0,
                    length: 0,
                    pageNumber: 0,
                    sortBy: "created_at",
                    orderBy: "DESC",
                    key: "",
                },
            }
        },
        mounted() {

            this.getListPembayaran();
            $(".showPageSearch").prop("style", "display:none");
            this.scroll()

	        this.backButtonPressed(this.backtopenggajian)
        },
        methods:{
            isdetailpembayaran() {
                $('#list_pembayaran').show();
                this.isSetDetailPembayaran = false;
                this.getListPembayaran(true);

                this.backButtonPressed(this.backtopenggajian)
            },

            godetailpembayaran(idpembayarangaji) {
                this.idpembayarangaji=idpembayarangaji
                this.isSetDetailPembayaran = true;
                $('#list_pembayaran').hide();
                this.backButtonPressed(this.$refs.setdetailpembayaran.backtoriwayat)
            },

            scroll() {
                window.onscroll = () => {
                    if ($('#loadingSpinnerListPembayaran').is(":hidden")) {
                        if ($(".showPageDefault").is(":visible")) {
                            if (this.listPembayaranPagination.pageNumber <= Math.ceil(this.listPembayaranPagination.length / this.listPembayaranPagination.limit)) {
                                if (Math.floor($(window).scrollTop()) > 0 && Math.floor($(window).scrollTop()) >= Math.floor($(document).height() - $(window).height()) - 100) {
                                    this.listPembayaranPagination.offset = (this.listPembayaranPagination.pageNumber * this.listPembayaranPagination.limit);
                                    if (this.listPembayaranPagination.offset > 0) {
                                        this.getListPembayaran();
                                    }
                                    $('#loadingSpinnerListPembayaran').show()
                                }
                            }
                        }
                    }

	                if ($('#loadingSpinnerListPembayaranSearch').is(":hidden")) {
		                if ($(".showPageSearch").is(":visible")) {
			                if (this.listPembayaranPagination.pageNumber <= Math.ceil(this.listPembayaranPagination.length / this.listPembayaranPagination.limit)) {
				                if (Math.floor($(window).scrollTop()) > 0 && Math.floor($(window).scrollTop()) >= Math.floor($(document).height() - $(window).height()) - 100) {
					                this.listPembayaranPagination.offset = (this.listPembayaranPagination.pageNumber * this.listPembayaranPagination.limit);
					                if (this.listPembayaranPagination.offset > 0) {
						                this.getListPembayaranSearch();
					                }
					                $('#loadingSpinnerListPembayaranSearch').show()
				                }
			                }
		                }
	                }
                }
            },
            backtopenggajian(){
                this.$emit('backtolistpenggajian')
            },


            detailpembayaran(id,idkaryawan){
                this.$emit('showdetailpembayaran',{idkaryawan: idkaryawan,idpembayaran:id})
            },

            add(){
                this.$emit('addpenggajian')
            },



            async getListPembayaran(refresh = false){
                if (refresh) {
                    this.listpembayaran = [];
                    this.listPembayaranPagination = {
                        limit: 20,
                            offset:0,
                            length: 0,
                            pageNumber: 0,
                            sortBy: "created_at",
                            orderBy: "DESC",
                    }
                }
                if (this.listPembayaranPagination.offset === 0) {
                    this.listpembayaran = [];
                    $('#loadingPage').addClass('overlayLoading');
                    $('#loadingPage').show()
                }
                try {
                    const response = await this.$axios.get(this.$baseurl + '/masterData/penggajian/meta/riwayat_penggajian_karyawan?sort_by=' + this.listPembayaranPagination.sortBy
                        + '&order_by='+ this.listPembayaranPagination.orderBy
                        + '&limit=' + this.listPembayaranPagination.limit
                        + '&offset=' + this.listPembayaranPagination.offset, this.requestHeaders)
                    if (response.data.status === true) {
                        $('#loadingPage').removeClass('overlayLoading');
                        $('#loadingPage').hide();
                        var pembayaranlist = response.data.data;
                        this.listPembayaranPagination.length += pembayaranlist.length
                        this.leght_data_pembayaranx=response.data.length_data;
                        this.listpembayaran.push(...pembayaranlist)
                        this.listPembayaranPagination.pageNumber++
                        $('#loadingSpinnerListPembayaran').hide()
                    }
                }  catch (e) {
                    this.$catch_error_response(e)
                    this.isClicked = false
                    $('#loadingPage').removeClass('overlayLoading');
                    $('#loadingPage').hide()
                    $('#textBtn2').show()
                    $('#btnNext').prop('disabled', false);
                }
            },

	        async getListPembayaranSearch(refresh = false){
		        if (refresh) {
			        this.listpembayaran = [];
			        this.listPembayaranPagination = {
				        limit: 20,
				        offset:0,
				        length: 0,
				        pageNumber: 0,
				        sortBy: "created_at",
				        orderBy: "DESC",
			        }
		        }
		        if (this.listPembayaranPagination.offset === 0) {
			        this.listpembayaran = [];
		        }
		        if (this.searchKeyPembayaran === "") {
		        	return
		        }
		        try {
			        let query = 'sort_by=' + this.listPembayaranPagination.sortBy
				        + '&order_by='+ this.listPembayaranPagination.orderBy
				        + '&limit=' + this.listPembayaranPagination.limit
				        + '&offset=' + this.listPembayaranPagination.offset
			        if (this.searchKeyPembayaran !== "") {
				        query += '&key=' + this.searchKeyPembayaran
			        }
			        const response = await this.$axios.get(this.$baseurl + '/masterData/penggajian/meta/riwayat_penggajian_karyawan?' + query, this.requestHeaders)
			        if (response.data.status === true) {
				        $('#loadingPage').removeClass('overlayLoading');
				        $('#loadingPage').hide();
				        var pembayaranlist = response.data.data;
				        this.listPembayaranPagination.length += pembayaranlist.length
				        this.leght_data_pembayaranx=response.data.length_data;
				        this.listpembayaran.push(...pembayaranlist)
				        this.listPembayaranPagination.pageNumber++
				        $('#loadingSpinnerListPembayaranSearch').hide()
			        }
		        }  catch (e) {
			        this.$catch_error_response(e)
			        this.isClicked = false
			        $('#loadingPage').removeClass('overlayLoading');
			        $('#loadingPage').hide()
			        $('#textBtn2').show()
			        $('#btnNext').prop('disabled', false);
		        }
	        },

            searchPembayaran(){
                $(".showPageSearch").show()
                // $(".showPageSearch").addClass('animated slideInDown')
                $("#textTopKasbon").text("Minimal 2 karakter")
                $(".showPageDefault").hide();
                $("#input_searchPembayaran").focus();
	            this.listpembayaran = [];
	            this.searchData()
            },
	        searchData() {
		        $("#textSearch").text("Minimal 2 karakter")
		        if (this.timer) {
			        clearTimeout(this.timer);
			        this.timer = null;
		        }
		        this.timer = setTimeout(() => {
			        // this.searchKeyPembayaran = "";
			        $(".spinner").prop("style", "display:inline-block");
			        this.getListPembayaranSearch(true)
		        }, 500);
	        },


            closeSearchPembayaran(){
                this.getListPembayaran();
                $(".showPageSearch").hide();
                $(".showPageSearch").removeClass('animated slideInDown');
                $(".showPageDefault").show();

                this.searchKeyPembayaran = "";
                $("#textTopPembayaran").text("Minimal 3 karakter")

	            this.getListPembayaran(true)


                this.listPembayaranSearchPagination = {
                    limit: 20,
                    offset:0,
                    length: 0,
                    pageNumber: 0,
                    sortBy: "created_at",
                    orderBy: "DESC",
                    key: "",
                }
            },

            async filter(payload) {
                this.listPembayaranPagination = payload.data
                await this.getListPembayaran();
                $("#dropdownMenuButton-" + payload.type).html(payload.textSorting)
            }
        }
    }
</script>

<style scoped>
.gaji-bersih {
	background: #EDEDED;
	padding: 2px 4px;
	border-radius: 4px;
}
</style>